import type { ReactElement, SVGProps } from 'react';

/**
 * The Slate product mark (rounded square + three bars). The container is drawn
 * with `fill="currentColor"` so it flips with the active theme — a dark navy
 * square on a light UI, a light square on a dark UI. The bars are always the
 * brand primary (#5B6EFC).
 */
export function SlateLogo(props: SVGProps<SVGSVGElement>): ReactElement {
  return (
    <svg
      viewBox="0 0 41 41"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden
      {...props}
    >
      <path
        fill="currentColor"
        d="M40.482,8.096l0,24.289c0,4.468 -3.628,8.096 -8.096,8.096l-24.289,0c-4.468,0 -8.096,-3.628 -8.096,-8.096l0,-24.289c0,-4.468 3.628,-8.096 8.096,-8.096l24.289,0c4.468,0 8.096,3.628 8.096,8.096Z"
      />
      <path
        fill="#5B6EFC"
        d="M10.159,14.108c-1.337,0 -2.423,-1.086 -2.423,-2.423c-0,-1.337 1.086,-2.423 2.423,-2.423l14.907,0c1.337,0 2.423,1.086 2.423,2.423c-0,1.337 -1.086,2.423 -2.423,2.423l-14.907,0Z"
      />
      <path
        fill="#5B6EFC"
        d="M10.159,22.664c-1.337,-0 -2.423,-1.086 -2.423,-2.423c0,-1.337 1.086,-2.423 2.423,-2.423l20.165,0c1.337,-0 2.423,1.086 2.423,2.423c0,1.337 -1.086,2.423 -2.423,2.423l-20.165,0Z"
      />
      <path
        fill="#5B6EFC"
        d="M10.159,31.219c-1.337,0 -2.423,-1.086 -2.423,-2.423c-0,-1.337 1.086,-2.423 2.423,-2.423l8.03,0c1.337,0 2.423,1.086 2.423,2.423c-0,1.337 -1.086,2.423 -2.423,2.423l-8.03,0Z"
      />
    </svg>
  );
}
